import { render, staticRenderFns } from "./videoPlay.vue?vue&type=template&id=52696782&scoped=true&"
import script from "./videoPlay.vue?vue&type=script&lang=js&"
export * from "./videoPlay.vue?vue&type=script&lang=js&"
import style0 from "./videoPlay.vue?vue&type=style&index=0&id=52696782&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52696782",
  null
  
)

export default component.exports